var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#2F89CE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.67535 10.187L6.9744 11.0443L7.87063 13.9279C7.9096 14.1227 8.1434 14.1617 8.29927 14.0448L9.58517 12.9926C9.70207 12.8757 9.89691 12.8757 10.0528 12.9926L12.3518 14.6682C12.5077 14.7851 12.7415 14.7072 12.7804 14.5124L14.495 6.32933C14.534 6.13449 14.3391 5.93966 14.1443 6.0176L4.67535 9.68047C4.44155 9.75841 4.44155 10.1091 4.67535 10.187ZM7.75374 10.6157L12.2739 7.84903C12.3518 7.81007 12.4297 7.92697 12.3518 7.96593L8.64997 11.434C8.53307 11.5509 8.41616 11.7067 8.41616 11.9016L8.29927 12.8368C8.29927 12.9537 8.10443 12.9926 8.06547 12.8368L7.59786 11.1222C7.48096 10.9274 7.5589 10.6936 7.75374 10.6157Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.f47ec94c.svg";
export { ForwardRef as ReactComponent };